export default function UploadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="24"
      viewBox="0 0 21 24"
      fill="none"
    >
      <path
        d="M20.3618 12.2571C19.5147 13.1113 18.1436 13.1172 17.2936 12.2512L12.6681 7.53103V21.798C12.6681 23.0128 11.6959 24 10.4995 24C9.30305 24 8.3337 23.0128 8.3337 21.798V7.53103L3.70238 12.2512C2.8582 13.1172 1.48423 13.1113 0.63714 12.2571C-0.209948 11.403 -0.212859 10.0079 0.631318 9.14483L8.96247 0.647291C8.96538 0.644335 8.96538 0.644335 8.96538 0.644335C9.16333 0.44335 9.40203 0.280788 9.66401 0.171429C9.926 0.0591133 10.2113 0 10.4995 0C10.7906 0 11.0758 0.0591133 11.3378 0.171429C11.5969 0.280788 11.8327 0.44335 12.0306 0.641379C12.0335 0.644335 12.0364 0.644335 12.0364 0.647291L20.3676 9.14483C21.2118 10.0079 21.2118 11.403 20.3618 12.2571Z"
        fill="currentColor"
      />
    </svg>
  );
}
